// extracted by mini-css-extract-plugin
module.exports = {"topImage":"TireHotel_topImage__1rlyy","content":"TireHotel_content__3B-H2","title":"TireHotel_title__27RXc"};